import api from "./api";

// GET /posts?page=
export const getPosts = (params = {}) =>
  api.get("/posts", { params }).then((res) => res.data);

// GET /posts/{slug}
export const getPost = (slug) =>
  api.get(`/posts/${slug}`).then((res) => res.data);
